<template>
  <a-layout-sider
    :width="settings.leftMenuWidth"
    :collapsible="settings.isMobileView ? false : true"
    :collapsed="settings.isMenuCollapsed && !settings.isMobileView"
    @collapse="onCollapse"
    :class="{
      [$style.menu]: true,
      [$style.white]: settings.menuColor === 'white',
      [$style.gray]: settings.menuColor === 'gray',
      [$style.dark]: settings.menuColor === 'dark',
      [$style.unfixed]: settings.isMenuUnfixed,
      [$style.shadow]: settings.isMenuShadow,
    }"
  >
    <div
      :class="$style.menuOuter"
      :style="{
        width:
          settings.isMenuCollapsed && !settings.isMobileView
            ? '80px'
            : settings.leftMenuWidth + 'px',
        height:
          settings.isMobileView || settings.isMenuUnfixed
            ? 'calc(100% - 64px)'
            : 'calc(100% - 110px)',
      }"
    >
      <div :class="$style.logoContainer" style="text-align: center">
        <div :class="$style.logo">
          <!-- <img src="resources/images/logo.svg" class="mr-2" alt="Clean UI" />
          <div :class="$style.name">{{ settings.logo }}</div>
          <div v-if="settings.logo === 'Clean UI Pro'" :class="$style.descr">
            Vue
          </div> -->
          <div :class="$style.name">SCG Debenture Club</div>
        </div>
      </div>
      <div :class="$style.banner">
        <div class="d-flex flex-nowrap align-items-start">
          <div
            class="mr-4 flex-shrink-0 align-self-start kit__utils__avatar kit__utils__avatar--size64"
          >
            <img src="resources/images/avatars/3.jpg" alt="Mary Stanform" />
          </div>
          <div class="flex-grow-1" style="margin-top: 12px">
            <div class="border-bottom">
              <div class="d-flex flex-wrap mb-2">
                <div class="mr-auto">
                  <div class="text-gray-6">
                    <span class="text-dark font-weight-bold">Admin Mua</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-custom-scrollbar
        :style="{
          height:
            settings.isMobileView || settings.isMenuUnfixed
              ? 'calc(100vh - 64px)'
              : 'calc(100vh - 180px)',
        }"
      >
        <a-menu
          forceSubMenuRender
          :inlineCollapsed="
            settings.isMobileView ? false : settings.isMenuCollapsed
          "
          :mode="'inline'"
          :selectedKeys="selectedKeys"
          :openKeys.sync="openKeys"
          @click="handleClick"
          @openChange="handleOpenChange"
          :inlineIndent="15"
          :class="$style.navigation"
        >
          <template v-for="(item, index) in menuData">
            <template
              v-if="
                mode != 'production' ||
                (!item.hide && (!item.roles || item.roles.includes(user.role)))
              "
            >
              <a-menu-item-group :key="index" v-if="item.category">
                <template slot="title">{{ item.title }}</template>
              </a-menu-item-group>
              <item
                v-if="!item.children && !item.category"
                :menu-info="item"
                :styles="$style"
                :key="item.key"
              />
              <sub-menu
                v-if="item.children"
                :menu-info="item"
                :styles="$style"
                :key="item.key"
              />
            </template>
          </template>
        </a-menu>
      </vue-custom-scrollbar>
    </div>
  </a-layout-sider>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import store from 'store';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { getMenuData } from '@/services/menu';
import SubMenu from './partials/submenu';
import Item from './partials/item';
import _ from 'lodash';
export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item },
  computed: {
    ...mapState(['settings']),
    ...mapGetters('user', ['user']),
  },
  data() {
    return {
      mode: process.env.NODE_ENV,
      menuData: [],
      selectedKeys: [],
      openKeys: [],
    };
  },
  mounted() {
    console.log(
      '[src\\components\\cleanui\\layout\\Menu\\MenuLeft\\index.vue]'
    );
    this._getMenuData();
    this.openKeys = store.get('app.menu.openedKeys') || [];
    this.selectedKeys = store.get('app.menu.selectedKeys') || [];
    this.setSelectedKeys();
  },
  watch: {
    'settings.isMenuCollapsed'() {
      this.openKeys = [];
    },
    $route() {
      this.setSelectedKeys();
    },
  },
  methods: {
    _getMenuData() {
      const menuData = getMenuData;
      const role_id_select =
        (this.$store &&
          this.$store.state &&
          this.$store.state.user &&
          this.$store.state.user.role_id_select) ||
        0;
      _.filter(menuData, (v, k) => {
        if (
          v.key == 'userManagement' ||
          v.key == 'divisionManagement' ||
          v.key == 'basicInfoManagement' ||
          v.key == 'roleManagement' ||
          v.key == 'configNotify'
        ) {
          if (role_id_select == 1) this.menuData.push(v);
        } else this.menuData.push(v);
      });
    },
    onCollapse: function (collapsed, type) {
      const value = !this.settings.isMenuCollapsed;
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMenuCollapsed',
        value,
      });
    },
    handleClick(e) {
      if (e.key === 'settings') {
        this.$store.commit('CHANGE_SETTING', {
          setting: 'isSettingsOpen',
          value: true,
        });
        return;
      }
      store.set('app.menu.selectedKeys', [e.key]);
      this.selectedKeys = [e.key];
    },
    handleOpenChange(openKeys) {
      store.set('app.menu.openedKeys', openKeys);
      this.openKeys = openKeys;
    },
    setSelectedKeys() {
      const pathname = this.$route.path;
      const menuData = this.menuData.concat();
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item);
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key));
          }
          return flattenedItems;
        }, []);
      const selectedItem = _.find(flattenItems(menuData, 'children'), [
        'url',
        pathname,
      ]);
      this.selectedKeys = selectedItem ? [selectedItem.key] : [];
    },
  },
};
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
